import { render, staticRenderFns } from "./AwsMailIntegration.vue?vue&type=template&id=79154b4f&scoped=true"
import script from "./AwsMailIntegration.vue?vue&type=script&lang=js"
export * from "./AwsMailIntegration.vue?vue&type=script&lang=js"
import style0 from "./AwsMailIntegration.vue?vue&type=style&index=0&id=79154b4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79154b4f",
  null
  
)

export default component.exports